var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompany = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 36,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#company_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 16,
  r: 14,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7D52F4",
  d: "M6 16C6 9.373 11.373 4 18 4s12 5.373 12 12-5.373 12-12 12S6 22.627 6 16"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#company_svg__b)",
  fillOpacity: 0.88,
  d: "m20.416 7.159-1.841-.492-1.552 5.772-1.401-5.211-1.842.492 1.514 5.63-3.771-3.758-1.348 1.344 4.136 4.122-5.15-1.376-.494 1.836 5.627 1.503a3.803 3.803 0 0 1 3.715-4.663 3.807 3.807 0 0 1 3.716 4.657l5.115 1.366.493-1.835-5.65-1.51 5.151-1.375-.493-1.835-5.65 1.509 3.77-3.758-1.348-1.344-4.078 4.065z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#company_svg__c)",
  fillOpacity: 0.88,
  d: "M21.72 17.037a3.8 3.8 0 0 1-.948 1.742l3.705 3.692 1.348-1.343z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#company_svg__d)",
  fillOpacity: 0.88,
  d: "M20.734 18.817a3.8 3.8 0 0 1-1.704 1.004l1.349 5.015 1.841-.492z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#company_svg__e)",
  fillOpacity: 0.88,
  d: "M18.962 19.84a3.83 3.83 0 0 1-1.97-.018l-1.35 5.02 1.842.491z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#company_svg__f)",
  fillOpacity: 0.88,
  d: "M16.927 19.804a3.8 3.8 0 0 1-1.674-1.019l-3.714 3.702 1.348 1.344z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#company_svg__g)",
  fillOpacity: 0.88,
  d: "M15.222 18.752a3.8 3.8 0 0 1-.925-1.72l-5.131 1.37.493 1.836z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "company_svg__b",
  x1: 18,
  x2: 18,
  y1: 6.667,
  y2: 34.972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "company_svg__c",
  x1: 18,
  x2: 18,
  y1: 6.667,
  y2: 34.972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "company_svg__d",
  x1: 18,
  x2: 18,
  y1: 6.667,
  y2: 34.972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "company_svg__e",
  x1: 18,
  x2: 18,
  y1: 6.667,
  y2: 34.972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "company_svg__f",
  x1: 18,
  x2: 18,
  y1: 6.667,
  y2: 34.972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "company_svg__g",
  x1: 18,
  x2: 18,
  y1: 6.667,
  y2: 34.972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.313,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "company_svg__a",
  width: 40,
  height: 40,
  x: -2,
  y: -2,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_245_18734"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_245_18734",
  result: "shape"
})))));
export { SvgCompany as ReactComponent };
export default __webpack_public_path__ + "671fb7f8904bac8e17210f14a9aa940b.svg";